import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';

const CalendarNavigation = ({
  showTodayButton = true,
  prevLabel = '‹',
  nextLabel = '›',
  todayLabel,
  className = '',
}) => {
  const { t } = useTranslation('calendar');
  const resolvedTodayLabel = todayLabel || t('today');
  const {
    weekLabel,
    isThisWeek,
    goToPrevWeek,
    goToNextWeek,
    goToToday,
  } = useCalendarNavigation();

  return (
    <div className={`calendar-navigation ${className}`}>
      <button
        type="button"
        className="calendar-navigation__prev"
        onClick={goToPrevWeek}
        aria-label={t('navigation.previousWeek')}
      >
        {prevLabel}
      </button>

      <div className="calendar-navigation__current">
        {weekLabel}
      </div>

      <button
        type="button"
        className="calendar-navigation__next"
        onClick={goToNextWeek}
        aria-label={t('navigation.nextWeek')}
      >
        {nextLabel}
      </button>
    </div>
  );
};

export default CalendarNavigation;
